import { useState } from 'react';
import { CheckIcon } from 'lucide-react';

import { Alert, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Field, FieldGroup, FieldLabel } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { Spinner } from '@/components/ui/spinner';
import { ApiError } from '../../lib/apiClient';
import { useAuth } from '../auth/useAuth';
import { useWijzigWachtwoord } from '../beheer/beheer.api';

/** Je eigen account. Het enige dat een buddy hier te zoeken heeft. */
export function AccountPaneel() {
  const wijzig = useWijzigWachtwoord();
  const { user } = useAuth();
  const [huidig, setHuidig] = useState('');
  const [nieuw, setNieuw] = useState('');
  const [melding, setMelding] = useState('');
  const [fout, setFout] = useState('');

  async function opslaan() {
    setFout('');
    setMelding('');
    try {
      await wijzig.mutateAsync({ huidig, nieuw });
      setHuidig('');
      setNieuw('');
      setMelding('Je wachtwoord is gewijzigd.');
    } catch (err) {
      setFout(err instanceof ApiError ? err.message : String(err));
    }
  }

  return (
    <form
      className="flex flex-col gap-4"
      onSubmit={(e) => {
        e.preventDefault();
        void opslaan();
      }}
    >
      {/* Je inlognaam is je e-mailadres, en die stond nergens. Alleen lezen:
          wijzigen raakt de toegang en loopt via een Admin. */}
      <Card>
        <CardHeader>
          <CardTitle>Mijn inlognaam</CardTitle>
          <CardDescription>
            Hiermee log je in, en hier komt de post van de app aan. Een Admin wijzigt hem.
          </CardDescription>
        </CardHeader>
        <CardContent>{user?.email}</CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Mijn wachtwoord</CardTitle>
          <CardDescription>
            Je huidige wachtwoord is nodig, ook nu je bent ingelogd.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <FieldGroup>
            <Field>
              <FieldLabel htmlFor="huidig-wachtwoord">Huidig wachtwoord</FieldLabel>
              <Input
                autoComplete="current-password"
                id="huidig-wachtwoord"
                onChange={(e) => setHuidig(e.target.value)}
                type="password"
                value={huidig}
              />
            </Field>
            <Field>
              <FieldLabel htmlFor="nieuw-wachtwoord">Nieuw wachtwoord</FieldLabel>
              <Input
                autoComplete="new-password"
                id="nieuw-wachtwoord"
                onChange={(e) => setNieuw(e.target.value)}
                type="password"
                value={nieuw}
              />
            </Field>
          </FieldGroup>
        </CardContent>
        <CardFooter className="justify-end">
          <Button disabled={!huidig || !nieuw || wijzig.isPending} type="submit">
            {wijzig.isPending && <Spinner data-icon="inline-start" />}
            {wijzig.isPending ? 'Bezig…' : 'Wijzigen'}
          </Button>
        </CardFooter>
      </Card>

      {melding && (
        <Alert>
          <CheckIcon />
          <AlertTitle>{melding}</AlertTitle>
        </Alert>
      )}
      {fout && (
        <Alert variant="destructive">
          <AlertTitle>{fout}</AlertTitle>
        </Alert>
      )}
    </form>
  );
}
